var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"checkout-page-layout"}},[_c('Header',{attrs:{"variant":"reduced","show-navigate-backwards-button":_vm.$store.state.checkout.headerSetup.showNavigateBackwardsButton,"show-goto-shop-link":_vm.$store.state.checkout.headerSetup.showGotoShopLink}}),_vm._v(" "),_c('Nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }